var map = {
	"./AudioElement.js": 59400,
	"./Canvas.js": 26112,
	"./DragDrop.js": 40816,
	"./EmbedMultimedia.js": 51404,
	"./Events/Onblur.js": 85196,
	"./Events/Onchange.js": 79212,
	"./Events/Onclick.js": 10144,
	"./Events/Oncopy.js": 48968,
	"./Events/Oncut.js": 82524,
	"./Events/Ondblclick.js": 69080,
	"./Events/Ondrag.js": 60908,
	"./Events/Ondragover.js": 61612,
	"./Events/Ondrop.js": 22788,
	"./Events/Onended.js": 43008,
	"./Events/Onfocus.js": 93420,
	"./Events/Oninput.js": 12384,
	"./Events/Onkeydown.js": 39072,
	"./Events/Onkeypress.js": 86216,
	"./Events/Onkeyup.js": 89776,
	"./Events/Onload.js": 56476,
	"./Events/Onmousedown.js": 89576,
	"./Events/Onmousemove.js": 56452,
	"./Events/Onmouseout.js": 13236,
	"./Events/Onmouseover.js": 14396,
	"./Events/Onmouseup.js": 64376,
	"./Events/Onpaste.js": 4580,
	"./Events/Onpause.js": 96736,
	"./Events/Onplay.js": 53016,
	"./Events/Onresize.js": 97144,
	"./Events/Onscroll.js": 5512,
	"./Events/Onsubmit.js": 57048,
	"./Events/Ontouchend.js": 99108,
	"./Events/Ontouchmove.js": 11752,
	"./Events/Ontouchstart.js": 64272,
	"./Events/Onunload.js": 28876,
	"./Events/Onvolumechange.js": 12780,
	"./Geolocation.js": 61000,
	"./HTMLAttribute.js": 13380,
	"./HTMLBasicBODYTags.js": 12688,
	"./HTMLBasicHEADTags.js": 41168,
	"./HTMLBasicHTMLTags.js": 33552,
	"./HTMLBasicTags.js": 38152,
	"./HTMLBlocks.js": 48024,
	"./HTMLClasses.js": 63968,
	"./HTMLColors.js": 14496,
	"./HTMLComments.js": 1864,
	"./HTMLCreateBookmark.js": 32300,
	"./HTMLCustomizeLinks.js": 35248,
	"./HTMLDefinitionLists.js": 73068,
	"./HTMLEditors.js": 70384,
	"./HTMLElements.js": 15224,
	"./HTMLEmojis.js": 7296,
	"./HTMLEntities.js": 84872,
	"./HTMLEvents.js": 97460,
	"./HTMLFavIcon.js": 62188,
	"./HTMLFonts.js": 84136,
	"./HTMLFormAttributes.js": 46664,
	"./HTMLFormElements.js": 20128,
	"./HTMLFormatting.js": 31568,
	"./HTMLForms.js": 73516,
	"./HTMLHeadings.js": 89959,
	"./HTMLIds.js": 60880,
	"./HTMLIframes.js": 47096,
	"./HTMLImages.js": 2072,
	"./HTMLInputAttributes.js": 62136,
	"./HTMLInputs.js": 171,
	"./HTMLIntro.js": 25760,
	"./HTMLJavascripts.js": 83812,
	"./HTMLLayout.js": 83992,
	"./HTMLLayouts.js": 78228,
	"./HTMLLists.js": 10316,
	"./HTMLMetaTags.js": 92552,
	"./HTMLOrderedLists.js": 45520,
	"./HTMLPageTitle.js": 54988,
	"./HTMLParagraphs.js": 26000,
	"./HTMLQuotations.js": 95595,
	"./HTMLSemantics.js": 83360,
	"./HTMLStyles.js": 30276,
	"./HTMLSymbols.js": 65176,
	"./HTMLTableColRowSpan.js": 15016,
	"./HTMLTableColgroup.js": 20992,
	"./HTMLTableStyling.js": 24592,
	"./HTMLTables.js": 40516,
	"./HTMLTags.js": 53144,
	"./HTMLTextLinks.js": 16716,
	"./HTMLUnorderedLists.js": 43672,
	"./Index.js": 80944,
	"./SVG.js": 86992,
	"./Tags/Article.js": 79667,
	"./Tags/Aside.js": 98824,
	"./Tags/BTag.js": 94568,
	"./Tags/BlockQuote.js": 46240,
	"./Tags/Body.js": 14876,
	"./Tags/BrTag.js": 70240,
	"./Tags/Button.js": 93476,
	"./Tags/Del.js": 37148,
	"./Tags/Details.js": 44240,
	"./Tags/Dialog.js": 66200,
	"./Tags/DoctypeHtml.js": 42075,
	"./Tags/EmTag.js": 71392,
	"./Tags/Footer.js": 32104,
	"./Tags/HTML.js": 99068,
	"./Tags/Head.js": 79704,
	"./Tags/Header.js": 60784,
	"./Tags/Headings.js": 97732,
	"./Tags/HrTag.js": 72092,
	"./Tags/ITag.js": 2219,
	"./Tags/Input.js": 32724,
	"./Tags/Ins.js": 61412,
	"./Tags/Label.js": 98732,
	"./Tags/LiTag.js": 21083,
	"./Tags/Link.js": 45763,
	"./Tags/Main.js": 86872,
	"./Tags/Mark.js": 26200,
	"./Tags/Meta.js": 760,
	"./Tags/Meter.js": 91424,
	"./Tags/Nav.js": 47032,
	"./Tags/NoScript.js": 44408,
	"./Tags/PTag.js": 2636,
	"./Tags/PreTag.js": 67144,
	"./Tags/Progress.js": 32192,
	"./Tags/Script.js": 31240,
	"./Tags/Section.js": 56164,
	"./Tags/Select.js": 77016,
	"./Tags/Small.js": 54580,
	"./Tags/Strong.js": 22588,
	"./Tags/Sub.js": 35628,
	"./Tags/Summary.js": 53804,
	"./Tags/Sup.js": 19724,
	"./Tags/TdTag.js": 77716,
	"./Tags/Textarea.js": 19220,
	"./Tags/ThTag.js": 47344,
	"./Tags/Title.js": 2884,
	"./Tags/TrTag.js": 88220,
	"./Tags/UTag.js": 97328,
	"./VideoElement.js": 48180,
	"./WebStorage.js": 22532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44164;